<h4 class="title text-center mb-2" style="margin-block-end: 1em">Admin Acknowledgment Click Through</h4>
<div class="form-group object admin-acknowledgement mt-3">
  <h5 class="mb-3" style="text-align: center; font-weight: 400">Subscriber Admin Agreement</h5>
  <p>
    This agreement should be acknowledged by the individual (Subscriber Administrator) who is responsible for
    communicating to ONEOK the identity of each Subscriber User.
  </p>
  <p>
    The information provided on this form is solely for the purposes of the Electronic Systems Access Agreement (the
    “Agreement”) between Subscriber and ONEOK, Inc. (“Company”) and is limited to that information necessary for Company
    to grant System access to the Subscriber Administrator. All capitalized terms not herein defined have the meanings
    ascribed to them in the Agreement.
  </p>
  <div class="container">
    <p>
      <strong><span>Acknowledgement and agreement by the Subscriber Administrator:</span></strong>
    </p>

    <ul>
      <li>
        I am aware of the Subscriber’s requirements for my role as Subscriber Administrator and agree to abide by them.
      </li>
      <li>I will ensure proper authorization for and documentation of requests for Subscriber User access.</li>
      <li>I will request Subscriber User access on a need-to-know basis.</li>
      <li>I will ensure proper record keeping of all Subscriber User access granted.</li>
      <li>I have read and understand the Agreement and agree to abide by it.</li>
    </ul>
  </div>
</div>
<div class="row">
  <div class="col d-flex justify-content-end">
    <input
      type="checkbox"
      class="btn-check"
      id="btn-check"
      autocomplete="off"
      (click)="toggleAcceptAccountAdminAcknowledgement($event)"
    />
    <label
      class="oneok-button oneok-pill oneok-blue"
      id="agreed-check"
      for="btn-check"
      style="margin: 1.5625rem 0 0 auto"
      [class]="!hasAgreed ? 'unagreed-check' : ''"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        fill="currentColor"
        class="bi bi-check2-square"
        viewBox="0 0 16 16"
      >
        <path
          d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z"
        />
        <path
          d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"
        />
      </svg>
      I accept this agreement.</label
    >
  </div>
</div>
<div class="row">
  <div class="col d-flex justify-content-end">
    <button
      type="button"
      class="oneok-button oneok-pill oneok-blue justify-content-cetner ph-no-capture"
      style="margin: 1.5625rem 0 0 auto"
      [disabled]="!hasAgreed"
      (click)="submitAccoutAdminAcknowledgement()"
    >
      <span class="spinner-border spinner-border-sm d-none" id="loading-spinner" role="status"></span>Submit
    </button>
  </div>
</div>
